import React from 'react';
import './App.css';
import PongGame from './pong';

const SHOW_PONG = false;

function App() {
  return (
    <div className="layout">
      <header className="site-header">
        <a href="/" className="logo" aria-label="RDynamix home">
          <img src={`${process.env.PUBLIC_URL}/logo.svg`} alt="RDynamix" className="logo-svg" />
        </a>
        <p className="status">Coming Soon</p>
      </header>

      <main>
        <section className="hero">
          <div className="hero-copy">
            <p className="kicker">RDynamix</p>
            <h1>
              Physical parts.
              <br />
              Live systems.
            </h1>
            <p className="lede">
              A studio for additive manufacturing and connected hardware.
              We are not open yet — this page is the placeholder until we are.
            </p>
          </div>
          <figure className="hero-figure" aria-hidden="true">
            <HeroComposition />
          </figure>
        </section>

        <section className="offerings" aria-label="Offerings">
          <article className="offering">
            <span className="index">01</span>
            <div className="offering-body">
              <h2>3D Printing</h2>
              <p>
                Short-run parts and prototypes printed to spec — geometries
                that tooling cannot justify, delivered without a factory line.
              </p>
            </div>
            <figure className="offering-art" aria-hidden="true">
              <LayerField />
            </figure>
          </article>

          <article className="offering offering-reverse">
            <span className="index">02</span>
            <div className="offering-body">
              <h2>IoT Solutions</h2>
              <p>
                Devices that sense, report, and act. Firmware, radios, and the
                software between a field unit and the screen that watches it.
              </p>
            </div>
            <figure className="offering-art" aria-hidden="true">
              <SignalField />
            </figure>
          </article>
        </section>
      </main>

      {SHOW_PONG && <PongGame />}

      <footer className="site-footer">
        <span>© {new Date().getFullYear()} RDynamix</span>
        <span>Coming Soon</span>
      </footer>
    </div>
  );
}

function HeroComposition() {
  return (
    <svg className="composition" viewBox="0 0 520 460" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g opacity="0.55" stroke="rgba(255,255,255,0.22)" strokeWidth="1">
        <polygon points="80,338 250,388 420,338 250,288" />
        <polygon points="88,308 250,356 412,308 250,260" />
        <polygon points="98,278 250,324 402,278 250,232" />
        <polygon points="110,248 250,292 390,248 250,204" />
        <polygon points="124,218 250,260 376,218 250,176" />
        <polygon points="140,190 250,228 360,190 250,152" />
      </g>
      <polygon
        points="140,190 250,228 360,190 250,152"
        stroke="#E32227"
        strokeWidth="1.4"
        fill="rgba(227,34,39,0.08)"
      />
      <path
        d="M168 198 C198 186, 214 210, 246 196 S302 168, 338 188"
        stroke="#E32227"
        strokeWidth="1.6"
        strokeLinecap="round"
      />
      <path
        d="M250 152 L250 78 M250 78 L198 46 M250 78 L312 38 M198 46 L162 62 M198 46 L210 18 M312 38 L348 22 M312 38 L334 68"
        stroke="rgba(255,255,255,0.28)"
        strokeWidth="1"
      />
      <circle cx="250" cy="78" r="3.5" fill="#E32227" />
      <circle cx="198" cy="46" r="3" fill="#fff" />
      <circle cx="312" cy="38" r="3" fill="#fff" />
      <circle cx="162" cy="62" r="2.5" fill="rgba(255,255,255,0.7)" />
      <circle cx="210" cy="18" r="2.5" fill="rgba(255,255,255,0.7)" />
      <circle cx="348" cy="22" r="2.5" fill="rgba(255,255,255,0.7)" />
      <circle cx="334" cy="68" r="2.5" fill="rgba(255,255,255,0.7)" />
    </svg>
  );
}

function LayerField() {
  const lines = [8, 20, 32, 44, 56, 68, 80, 92, 104];
  return (
    <svg className="field" viewBox="0 0 420 112" fill="none" xmlns="http://www.w3.org/2000/svg">
      {lines.map((y, i) => (
        <line
          key={y}
          x1={20 + i * 6}
          y1={y}
          x2={400 - i * 10}
          y2={y}
          stroke={i === 5 ? '#E32227' : 'rgba(255,255,255,0.22)'}
          strokeWidth={i === 5 ? 1.6 : 1}
        />
      ))}
    </svg>
  );
}

function SignalField() {
  const nodes = [
    [36, 78],
    [88, 34],
    [142, 62],
    [198, 24],
    [248, 70],
    [302, 40],
    [348, 84],
    [392, 32],
  ];
  const links = [
    [0, 1],
    [1, 2],
    [2, 3],
    [2, 4],
    [3, 5],
    [4, 5],
    [5, 6],
    [5, 7],
  ];
  return (
    <svg className="field" viewBox="0 0 420 112" fill="none" xmlns="http://www.w3.org/2000/svg">
      {links.map(([a, b]) => (
        <line
          key={`${a}-${b}`}
          x1={nodes[a][0]}
          y1={nodes[a][1]}
          x2={nodes[b][0]}
          y2={nodes[b][1]}
          stroke="rgba(255,255,255,0.22)"
          strokeWidth="1"
        />
      ))}
      {nodes.map(([x, y], i) => (
        <circle
          key={`${x}-${y}`}
          cx={x}
          cy={y}
          r={i === 5 ? 4 : 2.6}
          fill={i === 5 ? '#E32227' : '#ffffff'}
          opacity={i === 5 ? 1 : 0.75}
        />
      ))}
    </svg>
  );
}

export default App;
